<!--
 * @Author: vince
 * @Date: 2021-08-31 09:55:37
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2022-01-26 15:12:57
 * @Description: 
-->
<template>
  <el-select
    size="small"
    v-if="controlType == 'select'"
    :multiple="multiple"
    :loading="loading"
    v-model="valueTemp"
    placeholder="请选择学期"
    clearable
    @change="onChange"
  >
    <el-option
      v-if="multiple || checkAll"
      :value="null"
      label="全部"
    ></el-option>
    <el-option
      v-for="item in options"
      :value="item.value"
      :key="item.value"
      :label="item.label"
    ></el-option>
  </el-select>
  <el-checkbox-group
    size="small"
    v-else-if="controlType == 'checkbox'"
    v-model="checkTemp"
    @change="onChange"
  >
    <el-checkbox
      v-if="multiple || checkAll"
      label="全部"
      value="all"
      :indeterminate="indeterminate"
    ></el-checkbox>
    <el-checkbox
      v-for="(item, index) in options"
      :key="index"
      :label="item.value"
      >{{ item.label }}</el-checkbox
    >
  </el-checkbox-group>
</template>
<script>
export default {
  name: "schoolTermSelector",
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      loading: false,
      checkTemp: [],
      valueTemp: null,
      options: [
        // { label: "全部", value: 3 },
        { label: "上学期", value: 1 },
        { label: "下学期", value: 2 },
      ],
    };
  },
  watch: {
    value: {
      handler(v) {
        this.valueTemp = v;
        this.checkTemp = v;
      },
      immediate: true,
    },
  },
  props: {
    checkAll: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    controlType: {
      type: String,
      default: "select",
    },
    value: {
      type: Object | Array,
    },
  },
  created() {
    this.valueTemp = this.value;
  },
  methods: {
    onChange(v) {
      this.$emit("change", v);
    },
  },
};
</script>

<style>
</style>